<template>
<div data-component="ProgressBar.vue">
	<div v-if="header" class="mb-2 text-center text-base font-bold" :class="classes.text">
		{{ header }}
	</div>
	<div class="[ progress ] relative rounded-full bg-white">
		<div class="absolute rounded-full" :class="classes.bg" :style="styles"/>
	</div>
</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// @vuese
// Komponent odpowiedzialny za wyświetlenie paska postępu.
// @group Base Components

const colorConfig = {
	accent: {
		text: 'text-accent',
		bg: 'bg-accent',
	},
	info: {
		text: 'text-info-700',
		bg: 'bg-info-700',
	},
} as const;

const props = withDefaults(
	defineProps<{
		value: number;
		max?: number;
		color?: 'accent' | 'info';
		header?: string;
	}>(),
	{
		max: 100,
		color: 'accent',
		header: '',
	},
);

const classes = computed(() => colorConfig[props.color]);
const styles = computed(() => ({
	width: `${(props.value / props.max) * 100}%`,
}));
</script>

<style lang="scss" scoped>
.progress {
	width: 100%;
	height: 0.75rem;

	> div {
		top: 2px;
		bottom: 2px;
		left: 1px;
		max-width: calc(100% - 2px);
		transition: width 0.25s ease;
	}
}
</style>
